import { Outlet } from 'react-router-dom'

import { SurveyQuestionsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { useSurveyActions } from 'modules/engagement_surveys/hooks/useSurveyActions'
import NewFormEditor from 'modules/forms/components/newFormEditor'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function SurveyQuestionsPage() {
  const { surveyId } = useStrictParams<'surveyId'>()
  const { data, loading, error } = useQuery(SurveyQuestionsPageDocument, {
    variables: { surveyId: Number(surveyId) },
  })
  const survey = data?.surveys.survey

  const formId = survey?.form.id.toString() || ''
  const { handleActionClick } = useSurveyActions({ formId })

  if (!survey) return null

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="fullscreen"
      onActionClick={handleActionClick}
    >
      <NewFormEditor id={survey.form.id} resourceType="Surveys::Survey" formType="smart-survey" />
      <Outlet />
    </ResponsivePage.Body>
  )
}
